import commandes from "./commandes"
export default commandes;
